import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
import TabsList from './TabsList';
const NoteTabs = ({ tabs, editable = true, activeTabID, onTabChange, onAddTab, onEditTab, onDeleteTab, onViewHistory, onRearrangeTabs, tabAllowsHistory, ...columnProps }) => {
    const [{ theme, deviceType }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    return (React.createElement(Column, { flex: true, ...columnProps },
        React.createElement(Row, { pl: theme.spacing.page, pr: theme.spacing.standard.xs, pt: deviceType.isPhone ? theme.spacing.standard.lg : theme.spacing.standard.md, xAxis: "space-between", yAxis: "center" },
            React.createElement(Typography, { variant: TypographyVariant.BODY_TITLE }, translate('Tabs')),
            editable && tabs.length > 0 && onAddTab && React.createElement(Button, { variant: "text", onPress: onAddTab },
                React.createElement(FeatherIcon, { name: "plus" }))),
        React.createElement(TabsList, { tabs: tabs, editable: editable, activeTabID: activeTabID, onTabChange: onTabChange, onAddTab: onAddTab, onEditTab: onEditTab, onDeleteTab: onDeleteTab, onViewHistory: onViewHistory, onRearrangeTabs: onRearrangeTabs, tabAllowsHistory: tabAllowsHistory })));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default NoteTabs;
